import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";

const PasswordDigitContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.theme?.gainsboro};
  height: 46px;
  margin-right: 9px;
  flex: 1;
  justify-content: center;
  align-items: center;

  &:last-child {
    margin-right: 0;
  }
`;

const Digit = styled.div`
  color: ${(props) => props.theme?.blackLite};
  font-weight: 600;
  font-size: 19px;
`;

const PasswordDigit = (props) => {
  const { digit, key } = props;

  return (
    <PasswordDigitContainer key={key}>
      <Digit>{digit}</Digit>
    </PasswordDigitContainer>
  );
};

PasswordDigit.propTypes = {
  digit: PropTypes.string.isRequired,
  key: PropTypes.string,
};

export default withTheme(PasswordDigit);
